import MathUtils from './MathUtils'
import Vector2D from './Vector2D'
import socialSharing from './SocialSharing'
import './dndpolyfill'

import '../css/main.css'

const version = process.env.BUILD_TIME;

const isTouch = window.matchMedia('(hover: none)').matches
const game = document.querySelector('.game')
const gameContainer = document.querySelector('.game-screen-container')
const gameScreen = document.querySelector('.game-screen .game-zone')

const resizeGameWindow = () => {
  if (window.innerWidth < 800 || gameContainer.clientWidth + 32 > window.innerWidth) {
    document.body.classList.remove('landscape')
    document.body.classList.add('portrait')
  } else if (game.clientHeight > window.innerHeight) {
    document.body.classList.remove('portrait')
    document.body.classList.add('landscape')
  }
}

window.addEventListener('resize', resizeGameWindow)
resizeGameWindow()

const gameItems = [
  { name: 'diploma', locked: false, found: false, hint: 'Наши авторы статей тоже участвуют в спецпроекте по Deathloop!' },
  { name: 'scales', locked: false, found: false, hint: 'Авторы этого лендинга — не единственные, кто умеют анимировать на SG! Ещё неплохо справляются ..с и ...н!' },
  { name: 'pineapple', locked: false, found: false, hint: 'Вася удачно месил врагов в прямом эфире Deathloop. Может, от эфира на сайте что-то осталось?' },
  { name: 'obelisk', locked: false, found: false, hint: 'Deathloop уж давно вышла, а инфоповоды мы всё ещё находим.' },
  { name: 'youtube', locked: false, found: false, hint: 'На Twitch прятать предметы после стрима мы не можем. Но мы выкрутились!' },
  { name: 'arm', locked: false, found: false, hint: 'Слышали последние НОВОСТИ о Deathloop?' },
  { name: 'poison', locked: false, found: false, hint: 'Геннадий Воробьев и Андрей Маковеев не на этом лендинге. Но они продолжают следить за Deathloop!' },
  { name: 'suitcase', locked: false, found: false, hint: 'Открываете наши дэзлупные видео только на YouTube, а не на сайте? Зря, зря, зря...' }
];

interface Author {
  name: string,
  pos: [number, number, number],
  deathPos?: [number, number, number],
  hitbox: [number, number, number, number],
  cross: [number, number],
  item: string,
  deathTime: number,
  deathHeader: string,
  deathText: string,
  shareText: string
}

const authors: Author[] = [
  { name: 'vasya', pos: [20, 2.035, 71.24], hitbox: [24, 3, 10, 60.1], cross: [17, 34], item: 'diploma', deathHeader: 'Василий Гальперов ликвидирован', deathText: 'Гальперов присваивает любой диплом на своем пути, так что давно пора заземлить его дипломом по деградации. Теперь пойдёт делать историю серии «Якудза», а то чё, сильно умный?!', deathTime: 80, shareText: 'Гальперов, иди делать историю серии «Якудза», а то чё, сильно умный?!' },
  { name: 'katya', pos: [8.32, 27.54, 54.59], deathPos: [8.32, 17.54, 54.59], hitbox: [14.5, 29.7, 5.1, 43.2], cross: [19, 23], item: 'youtube', deathHeader: 'Катерина Краснопольская ликвидирована', deathText: 'Вывалили все комментарии токсиков на самую беззащитную! Ну не, это уже перебор. Хватит расстраивать Катю комментариями!', deathTime: 169, shareText: 'Хорош буллить Краснополоьскую в комментах, у неё самый клевый контент!' },
  { name: 'fen', pos: [6.86, 17.28, 67.59], hitbox: [13, 18.3, 9.2, 55.8], cross: [17, 13], item: 'pineapple', deathHeader: 'Иван Лоев ликвидирован', deathText: 'У Фена в жизни 2 вещи: плов и работа. И плов уже испорчен ананасами! Как устанет давиться, сразу пойдёт делать «Ретрозор».', deathTime: 95, shareText: 'Лоев, верни обратно «Ретрозор», а то зачем возрождали-то?' },
  { name: 'max-mil', pos: [23.64, 35.24, 62.91], deathPos: [20.84, 25.54, 65.91], hitbox: [28.4, 37.6, 5, 51.9], cross: [20, 20], item: 'arm', deathHeader: 'Максим Милязев ликвидирован', deathText: 'Господин Милязев, вы юрист или косплеер? Ваша рука из настолки по Cyberpunk сделала выбор, так что с таким лицом только на стримы по DnD!', deathTime: 107, shareText: 'Стопгейм, когда вернете стримы по словесным играм? Требую больше безумств от Милязева!' },
  { name: 'wes', pos: [18.97, 45.06, 53.86], deathPos: [14.57, 40.26, 58.26], hitbox: [22.9, 46.8, 4.2, 45.8], cross: [24, 25], item: 'scales', deathHeader: 'Александр Вилисов ликвидирован', deathText: 'Уэс, с таким весом ты точно НЕ ОЧЕНЬ МОБИЛЬНЫЙ. Чтобы сделать историю серии МК, тебе нужно быть в форме!', deathTime: 53, shareText: 'Однажды я заставлю Уэса сделать историю серии Mortal Kombat. Однажды….' },
  { name: 'gleb', pos: [11.67, 67.90, 41.75], deathPos: [8.87, 65.2, 41.75], hitbox: [14.3, 68, 5.5, 35], cross: [18, 36], item: 'poison', deathHeader: 'Глеб Мещеряков ликвидирован', deathText: 'Глеб, вернись в детство и расскажи уже про новую старую консоль! Когда выпуск про Dendy?!', deathTime: 109, shareText: 'Хочу, чтобы Мещеряков сделал ролик про Dendy. Когда уже?!' },
  { name: 'flynn', pos: [25.25, 57.76, 64.52], deathPos: [25.65, 52.86, 64.52], hitbox: [31.9, 57.7, 8.2, 52.3], cross: [16, 30], item: 'obelisk', deathHeader: 'Дмитрий Бурдуков ликвидирован', deathText: 'Сделали Флинна единым! Даже не уверены, что для него это наказание. Но пусть еще что-то по Dead Space придумает, надоел! Может спецвыпуск мультсериала?', deathTime: 63, shareText: 'А прикиньте, Уэс и Флинн про Dead Space?! Хочу!!' },
  { name: 'kungur', pos: [10.94, 81.35, 47.59], deathPos: [19.94, 79.35, 40.59], hitbox: [15.2, 83.1, 4.3, 40.1], cross: [19, 25], item: 'suitcase', deathHeader: 'Дмитрий Кунгуров ликвидирован', deathText: 'Пусть чемоданы уже выбьют из Кунгуров все дерьмо, и он пойдет ХОТЬ ЧТО-ТО ПОДЕЛАЕТ. Узнали, согласны?', deathTime: 2, shareText: 'Кунгуров, либо ты делаешь новый контент, либо мы проводим выборы нового главреда. Понял?!' },
]
const gameItemList = document.querySelector('.game-items-list')

const supportsWebp = () => {
    const elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
}

let staticExt = 'webp'
let animatedExt = 'webp'

if (!supportsWebp()) {
  staticExt = 'png'
  animatedExt = 'gif'
}

let soundEnabled = false

class ProgressBar {
  total = 1
  loaded = 0

  init = (total) => {
    this.total = total
    this.render()
  }

  increment = () => {
    this.loaded += 1
    this.render()
  }

  render = () => {
    const percentage = this.loaded === 0 ? 0 : this.loaded/this.total * 100
    gameScreen.innerHTML = `<div class="loader">
        <span>Загрузка…</span>
        <div class="loader-bar">
            <div class="loader-bar-progress" style="width: ${percentage}%"></div>
        </div>
    </div>`
  }

  continue = () => {
    gameScreen.innerHTML = '<div class="loader"></div>'
    return new Promise<void>(resolve => {
      const buttOn = document.createElement('button')
      buttOn.classList.add('modal-button')
      buttOn.innerHTML = 'Cо звуком'
      buttOn.addEventListener('click', () => {
        soundEnabled = true
        this.destroy()
        resolve()
      })
      const buttOff = document.createElement('button')
      buttOff.classList.add('modal-button')
      buttOff.innerHTML = 'Без звука'
      buttOff.addEventListener('click', () => {
        this.destroy()
        resolve()
      })
      const buttonsContainer = document.createElement('div')
      buttonsContainer.style.display = 'flex'
      buttonsContainer.style.gap = '10px'
      buttonsContainer.style.width = '80%'
      buttonsContainer.style.justifyContent = 'center'
      buttonsContainer.append(buttOn)
      buttonsContainer.append(buttOff)
      document.querySelector('.loader').append(buttonsContainer)
    })
  }

  destroy = () => {
    gameScreen.innerHTML = ''
  }
}

const progressBar = new ProgressBar()

const preloadImage = (name, isAnimated = false) => {
  let extension = staticExt

  if (isAnimated) {
    extension = animatedExt
  }

  return new Promise<void>((resolve) => {
    const img = document.createElement('img')
    img.onload = () => {
      progressBar.increment()
      resolve();
    }
    img.onerror = () => {
      progressBar.increment()
      resolve();
    }
    img.src = `./dist/img/${name}.${extension}?${version}`
  })
}

const preloadAudio = (filename) => {
  return new Promise<void>((resolve) => {
    resolve()
    const audio = new Audio(`./dist/audio/${filename}.mp3?${version}`)
    audio.addEventListener('canplay', () => {
      resolve()
    })
    audio.addEventListener('error', (e) => {
      console.error(e)
      resolve()
    })
    audio.load();
  })
}

const preloadItems = async () => {
  await fetch('https://stopgame.ru/ajax/deathloop/get', {
    credentials: 'include'
  })
    .then(response => response.json())
    .then(result => {
      result.forEach(itemName => {
        const foundItem = gameItems.find(item => item.name === itemName)
        if (!foundItem) {
          return
        }
        foundItem.found = true
      })
    })
    .catch(e => {
      console.error(e)
    })
}

const preloadGame = async () => {
  const assets = [
    preloadItems(),
    preloadImage('game_bg'),
    preloadAudio('error'),
    preloadAudio('ambience'),
  ]
    .concat(gameItems.map(item => {
      return preloadImage(`${item.name}`)
    }))
    .concat(authors.flatMap(author => {
      return [
        preloadAudio(`${author.name}-death`),
        preloadImage(`${author.name}-idle`, true),
        preloadImage(`${author.name}-death`, true),
        preloadImage(`${author.name}-dead`, true),
        preloadImage(`${author.name}-bg`)
      ]
    }))

  progressBar.init(assets.length)

  await Promise.all(assets)
    .then(progressBar.continue)
    .catch(e => {
      console.log(e)
      progressBar.continue()
    })
}

/*const stringToColour = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
}*/

const playAudio = (filename: string, volume: number, loop = false) => {
  if (!soundEnabled) {
    return
  }

  const audio = new Audio(`./dist/audio/${filename}.mp3?${version}`)
  audio.volume = volume
  audio.loop = loop
  // noinspection JSIgnoredPromiseFromCall
  audio.play()
}

type GameAuthor = Author & Partial<{
  dead: true,
  element: HTMLImageElement,
  hitboxElement: HTMLDivElement
}>

class GameController {
  firstPass = true
  dragUpdateInterval = 1000 / 30
  activeItem = undefined
  activeItemElement = undefined
  authors: GameAuthor[] = authors

  kill = (author: GameAuthor) => {
    author.dead = true
    author.element.src = `./dist/img/${author.name}-dead.${animatedExt}?${version}`
    if (author.deathPos) {
      author.element.style.top = `${author.deathPos[0]}%`
      author.element.style.left = `${author.deathPos[1]}%`
      author.element.style.height = `${author.deathPos[2]}%`
    }
    author.element.classList.remove('author--hover')
    const authorModal = document.querySelector<HTMLTemplateElement>('#author-death-modal').content.cloneNode(true) as DocumentFragment
    const authorImg = authorModal.querySelector<HTMLImageElement>('.author-img.author-img-1');
    const authorImg2 = authorModal.querySelector<HTMLImageElement>('.author-img.author-img-2');
    authorImg.src = `./dist/img/${author.name}-death.${animatedExt}?${version}`
    authorImg2.src = `./dist/img/${author.name}-dead.${animatedExt}?${version}`
    authorImg.onload = () => {
      setTimeout(() => {
        authorImg.style.display = 'none'
        authorImg2.style.display = 'block'
      }, author.deathTime * 100)
    }
    authorModal.querySelector<HTMLImageElement>('.author-bg').src = `./dist/img/${author.name}-bg.${staticExt}?${version}`
    authorModal.querySelector('h1').innerText = author.deathHeader
    authorModal.querySelector('p').innerText = author.deathText
    socialSharing([authorModal.querySelector('.share-buttons')], author.name, author.shareText, `https://promo.stopgame.ru/dist/img/share-${author.name}.${staticExt}`)
    showModal(authorModal)
    playAudio(`${author.name}-death`, 0.6)
    this.activeItemElement.setAttribute('disabled', 'true')
    this.activeItemElement.removeAttribute('draggable')
    document.querySelectorAll('.game-item').forEach(item => item.classList.remove('active'))
    this.activeItem = undefined
    this.activeItemElement = undefined
  }

  showError = (author) => {
    author.hitboxElement.style.opacity = '1';
    author.element.classList.remove('author--hover')
    playAudio('error', 0.2);
    setTimeout(() => author.hitboxElement.style.opacity = '0', 1200);
    document.querySelectorAll('.game-item').forEach(item => item.classList.remove('active'))
    this.activeItem = undefined
    this.activeItemElement = undefined
  }

  render() {
    const authorsContainer = document.createElement('div')
    authorsContainer.classList.add('authors-container')
    gameScreen.append(authorsContainer)
    const bg = document.createElement('img')
    bg.src = `./dist/img/game_bg.${staticExt}?${version}`
    bg.classList.add('game-bg')
    authorsContainer.append(bg)
    this.authors.forEach(author => {
      if (!author.name) {
        return
      }
      const img = document.createElement('img')
      img.src = `./dist/img/${author.name}-idle.${animatedExt}?${version}`
      img.classList.add('author')
      img.style.top = `${author.pos[0]}%`
      img.style.left = `${author.pos[1]}%`
      img.style.height = `${author.pos[2]}%`
      const hitbox = document.createElement('div')
      authorsContainer.append(img)
      author.element = img
      if (author.hitbox) {
        hitbox.classList.add('author-hitbox')
        hitbox.style.top = `${author.hitbox[0]}%`
        hitbox.style.left = `${author.hitbox[1]}%`
        hitbox.style.width = `${author.hitbox[2]}%`
        hitbox.style.height = `${author.hitbox[3]}%`
        /*hitbox.style.backgroundColor = stringToColour(author.name)*/
        hitbox.innerHTML = `<svg viewBox="0 0 106 106" style="top: ${author.cross[0]}%; left: ${author.cross[1]}%"><use xlink:href="#cross" /></svg>`
        if (!isTouch) {
          hitbox.addEventListener('mouseenter', () => {
            if (!author.dead && !isTouch) {
              author.element.classList.add('author--hover')
            }
          })
          hitbox.addEventListener('dragenter', (event) => {
            event.preventDefault()
            if (!author.dead && !isTouch) {
              author.element.classList.add('author--hover')
            }
          })
          hitbox.addEventListener('dragover', (event) => {
            event.preventDefault()
          })
          hitbox.addEventListener('mouseleave', () => {
            if (!author.dead) {
              author.element.classList.remove('author--hover')
            }
          })
          hitbox.addEventListener('dragleave', () => {
            if (!author.dead) {
              author.element.classList.remove('author--hover')
            }
          })
          hitbox.ondrop = (event) => {
            if (author.dead) {
              return
            }
            event.preventDefault()
            const text = event.dataTransfer.getData('text/plain')
            if (text.startsWith('try-')) {
              const item = text.replace('try-', '')
              if (item === author.item) {
                this.kill(author)
              } else {
                this.showError(author)
              }
            }
          }
        } else {
          hitbox.addEventListener('click', () => {
            if (this.activeItem) {
              if (this.activeItem === author.item) {
                this.kill(author)
              } else {
                this.showError(author)
              }
            }
          })
        }
        authorsContainer.append(hitbox)
        author.hitboxElement = hitbox
      }
    })

    document.body.ondrop = (event) => {
      event.preventDefault()
    }

    const blankImage = new Image()
    blankImage.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    gameItemList.innerHTML = '';
    gameItems.forEach((item, index) => {
      const element = document.createElement('div')
      element.classList.add('game-item')
      if (item.locked) {
        element.classList.add('game-item--inactive')
        element.innerHTML = '<svg class="lock"><use xlink:href="#lock"/></svg>'
        element.addEventListener('click', () => showModal(`locked`))
      } else if (!item.found) {
        element.innerHTML = '<svg class="hint"><use xlink:href="#hint"/></svg>'
        element.addEventListener('click', () => {
          const template = document.querySelector<HTMLTemplateElement>('#hint-modal').content.cloneNode(true) as DocumentFragment
          template.querySelector('h1').innerText = `Предмет №${index + 1}`
          template.querySelector('p').innerText = item.hint
          showModal(template)
        })
      } else {
        const img = document.createElement('img')
        img.src = `./dist/img/${item.name}.${staticExt}?${version}`

        if (!isTouch) {
          element.draggable = true

          const tempElement = document.createElement('img')
          tempElement.src = img.src
          tempElement.classList.add('temp-drag-element')
          let dragIntervalId = undefined

          let calculatedAngleDeg: number;
          let currentDrag = new Vector2D();
          let oldDrag = new Vector2D();
          let diffDrag = new Vector2D();

          const updateDrag = (elementRef) => {
            currentDrag.x = parseInt(elementRef.style.left.replace('px', ''));
            currentDrag.y = parseInt(elementRef.style.top.replace('px', ''));

            diffDrag.x = currentDrag.x - oldDrag.x;
            diffDrag.y = currentDrag.y - oldDrag.y;

            let speedX = Math.abs(diffDrag.x) / this.dragUpdateInterval;
            speedX = speedX * 3;
            calculatedAngleDeg = MathUtils.mapInterval(speedX, 0.0, 5.0, 0.0, 90);

            calculatedAngleDeg = calculatedAngleDeg * (diffDrag.x > 0 ? 1.0 : -1.0);
            elementRef.style.transform = `rotate(${calculatedAngleDeg}deg)`

            oldDrag.x = currentDrag.x;
            oldDrag.y = currentDrag.y;
          }

          element.ondragstart = (e) => {
            img.classList.add('hide')
            e.dataTransfer.setDragImage(blankImage, 50, 50)
            e.dataTransfer.setData('text/plain', `try-${item.name}`);
            document.body.append(tempElement)
            dragIntervalId = setInterval(() => updateDrag(tempElement), this.dragUpdateInterval);
            this.activeItem = item.name
            this.activeItemElement = element
          }

          element.ondrag = (event) => {
            if (tempElement) {
              const x = event.x - tempElement.clientWidth / 2
              const y = event.y - 20;

              tempElement.style.display = 'block'
              tempElement.style.left = `${x}px`
              tempElement.style.top = `${y}px`
            }
          }

          element.ondragend = () => {
            img.classList.remove('hide')
            if (dragIntervalId) {
              clearInterval(dragIntervalId)
            }
            tempElement.style.display = 'none'
            tempElement.remove()
          }
        } else {
          element.addEventListener('click', () => {
            document.querySelectorAll('.game-item').forEach(itemBtn => {
              if (itemBtn !== element) {
                itemBtn.classList.remove('active')
              }
            })
            element.classList.toggle('active')
            if (element.classList.contains('active')) {
              this.activeItem = item.name
              this.activeItemElement = element
            } else {
              this.activeItem = undefined
              this.activeItemElement = undefined
            }
          })
        }
        element.append(img)
      }
      gameItemList.append(element)
    })

    const scrollbar = document.createElement('div')
    scrollbar.classList.add('scrollbar')
    const scrollbarThumb = document.createElement('button')
    scrollbarThumb.classList.add('scrollbar-thumb')
    let isDrag = false
    scrollbar.addEventListener('mousedown', () => {
      isDrag = true

      const mouseup = () => {
        isDrag = false
        document.removeEventListener('mouseup', mouseup)
        document.removeEventListener('mousemove', mousemove)
      }

      const mousemove = (event) => {
        const scrollbarPos = scrollbar.getBoundingClientRect()
        if (isDrag) {
          let pos = event.x - scrollbarPos.left
          if (pos < 0) {
            pos = 0;
          } else if (pos > scrollbarPos.width) {
            pos = scrollbarPos.width
          }

          const percentage = pos / scrollbarPos.width;
          //scrollbarThumb.style.left = `calc(${percentage*100}% - 25px)`
          gameScreen.scrollLeft = (gameScreen.scrollWidth - gameScreen.clientWidth) * percentage
        }
      }

      document.addEventListener('mouseup', mouseup)
      document.addEventListener('mousemove', mousemove)
    })

    gameScreen.addEventListener('scroll', () => {
      const percentage = gameScreen.scrollLeft / (gameScreen.scrollWidth - gameScreen.clientWidth)
      scrollbarThumb.style.left = `calc(${percentage*100}% - 25px)`
    })

    scrollbar.innerHTML = '<div class="scrollbar-line"></div>'
    scrollbar.append(scrollbarThumb)
    gameScreen.parentElement.append(scrollbar)

    playAudio('ambience', 0.6, true)
  }
}

const showModal = (template: string|DocumentFragment) => {
  const modal = document.querySelector<HTMLTemplateElement>('#modal').content.cloneNode(true) as DocumentFragment
  let content: DocumentFragment;
  if (typeof template === 'string') {
    content = document.querySelector<HTMLTemplateElement>(`#${template}`).content.cloneNode(true) as DocumentFragment
  } else {
    content = template
  }
  content.querySelectorAll('[data-modal-close]').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.modal-overlay').forEach(node => node.remove())
    })
  })
  modal.querySelector('.modal').append(content)
  document.body.append(modal)
}

document.querySelector('.whats-happening').addEventListener('click', () => {
  showModal('whats-happening')
})

preloadGame()
  .then(() => {
    const gameController = new GameController()
    gameController.render()
  })
